import './index.scss'
import {HelpIcon} from '../../../icons'
import {useEffect, useRef, useState} from 'react'
import Error from '../error'
import classNames from 'classnames'
import {useSelector} from 'react-redux'
import Tooltip from '../tooltip'
import {colors} from '../../../utils/colors'

const Textarea = ({
    name,
    placeholder,
    value = '',
    onChange,
    defaultValue,
    innerRef,
    error,
    infoText,
    isDisabled,
    activeInfo,
    handleInfo,
    minLength = null,
    placeholderAsLabel = true,
    customIcon,
    customIconOnclick,
    ...props
}) => {
    const [charCount, setCharCount] = useState(0)
    const [hasValue, setHasValue] = useState(false)

    const ref = useRef()
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const placeholderClassName = hasValue ? 'has-value' : 'empty'

    const handleChange = e => {
        const length = e.target.value.length
        setCharCount(length)
        onChange(e)
    }

    const getCountClass = () => {
        if (minLength && charCount) {
            return charCount >= minLength ? 'success' : 'error'
        }
        return ''
    }

    const updateLabelVisibility = () => {
        if (placeholderAsLabel) {
            const inputText = ref?.current?.value
            const condition = inputText?.length
            setHasValue(condition)
        }
    }

    useEffect(() => {
        if (value?.length === 0) {
            setCharCount(0)
        }
        updateLabelVisibility()
    }, [value])

    return (
        <div className="form-element">
            <div className={classNames('textarea', {
                dark: isDarkMode
            })}>
                <textarea
                    onInput={updateLabelVisibility}
                    placeholder={!placeholderAsLabel && placeholder}
                    name={name}
                    onChange={handleChange} disabled={isDisabled}
                    ref={ref || innerRef}
                    id={name}
                    value={value}
                    defaultValue={defaultValue}
                    className={classNames({
                        'simple-textarea': true,
                        error,
                        [placeholderClassName]: placeholderAsLabel,
                        dark: isDarkMode
                    })}
                    {...props}
                />
                {placeholderAsLabel && (
                    <span className={classNames({
                        'input-placeholder': true,
                        [placeholderClassName]: placeholderClassName
                    })}>{placeholder}</span>
                )}
                {infoText && (
                    <Tooltip placement="right" trigger="click" content={<span dangerouslySetInnerHTML={{__html: infoText}}/>}>
                        <HelpIcon stroke={colors.colorBgFilter} width='22' height='22' />
                    </Tooltip>
                )}
                {customIcon && (
                    <div className="help" onClick={customIconOnclick}>
                        <span>{customIcon}</span>
                    </div>
                )}
            </div>
            <div className={classNames({
                'validation-box': true,
                'justify-content-start': !minLength
            })}>
                {minLength && <span className={`count ${getCountClass()}`}>{charCount}</span>}
                {error && <Error error={error}/>}
            </div>
        </div>
    )
}

export default Textarea
